<template>
  <Card class="px-5 py-3 px-md-8 py-md-4" :class="{'requested': requestDone, 'isDisplayed': applicant.isDisplay}">
    <FlexColumn>
      <ApplicantCardHeader :applicant="applicant" :targetJob="targetJob" :requestorId="requestorId" />
      <Divider class="mb-4" />
      <FlexRow
        :space="2"
        :style="{
          'flex-direction': smAndDown ? 'column !important' : undefined,
          gap: smAndDown ? '16px' : undefined
        }"
      >
        <FlexColumn
          :space="2"
          :style="{flex: smAndDown ? undefined : '1 1 300px'}"
        >
          <ApplicantAcademicHistory :applicant="applicant" />
          <ApplicantCareers :applicant="applicant" />
        </FlexColumn>

        <FlexColumn
          :space="2"
          :style="{flex: smAndDown ? undefined : '5 1 400px'}"
        >
          <ApplicantServicesTools :applicant="applicant" />
        </FlexColumn>

        <FlexColumn
          :space="2"
          :style="{flex: smAndDown ? undefined : '2 1 250px'}"
        >
          <ApplicantPositions :applicant="applicant" />
          <ApplicantDesiredConditions :applicant="applicant" :targetJob="targetJob" />
        </FlexColumn>
      </FlexRow>
      <FlexRow :space="0" justify="space-between" align="center" class="mt-2">
        <FlexRow v-if="isHotList" align="center" justify="space-between" full-width class="mr-4" >
          <FlexRow align="center">
            <FlexColumn width="80px" justify="center">
              <Chip size="m" color="red" text-color="white" un-clickable>
                {{remainingDays}}
              </Chip>
            </FlexColumn>
            <Label :text="signalEvent" color="gray" />
          </FlexRow>
          <TextButton v-if="!requestDone"  depressed @click="handleIgnoreApplicant">
            <Label text="非表示" />
          </TextButton>
        </FlexRow>
        <FlexRow v-else align="center">
          <Label v-if="requestDone" text="スカウト送信日"/>
          <Label :text="requestedAt"/>
          <Chip v-if="requestByProxy" outlined>
            <v-icon small>mdi-star</v-icon>
            OS
          </Chip>
        </FlexRow>
        <TextButton :outlined="requestDone" :primary="!requestDone" depressed @click="handleClickDetail">
          <v-icon class="mr-1">{{requestDone ? 'mdi-check' : 'mdi-email-outline'}}</v-icon>
          <Label :text="requestDone ? 'スカウト済み' : '詳細/スカウト'" />
        </TextButton>
      </FlexRow>
    </FlexColumn>
  </Card>
</template>

<script>
import Card from "@/components/atoms/Card";
import FlexColumn from "@/components/atoms/FlexColumn";
import Divider from "@/components/atoms/Divider";
import FlexRow from "@/components/atoms/FlexRow";
import ApplicantCardHeader from "@/components/molecules/ApplicantCardHeader";
import ApplicantPositions from "@/components/molecules/ApplicantPositions";
import ApplicantDesiredConditions from "@/components/molecules/ApplicantDesiredConditions";
import ApplicantAcademicHistory from "@/components/molecules/ApplicantAcademicHistory";
import ApplicantCareers from "@/components/molecules/ApplicantCareers";
import ApplicantServicesTools from "../molecules/ApplicantServicesTools";
import Label from "../atoms/Label";
import ComponentMixin from "../ComponentMixin";
import Chip from "../atoms/Chip";
import TextButton from "../atoms/TextButton";

export default {
  name: "ApplicantCard",
  mixins: [ComponentMixin],
  components: {
    TextButton,
    Chip,
    Label,
    ApplicantServicesTools,
    ApplicantCareers,
    ApplicantAcademicHistory,
    ApplicantDesiredConditions,
    ApplicantPositions,
    ApplicantCardHeader,
    FlexRow,
    Divider,
    FlexColumn,
    Card
  },
  props: {
    applicant: {
      type: Object
    },
    requestorId: {
      type: String
    },
    targetJob: {
      type: Object
    }
  },
  data() {
    return {
      reasons: []
    }
  },
  computed: {
    jobId() {
      return this.$route.params.id
    },
    requestDone() {
      return !!this.applicant.chatRequest
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown
    },
    requestedAt() {
      if (this.applicant.chatRequest) {
        return this.dateToText(this.applicant.chatRequest.requestedAt)
      }
      return ""
    },
    requestByProxy() {
      if (this.applicant.chatRequest) {
        return this.applicant.chatRequest.byProxy
      }
      return false
    },
    isHotList() {
      return this.applicant.signal
    },
    remainingDays() {
      return this.toRemainingDays(this.applicant.signal.createdAt,14)
    },
    signalEvent() {
      const signalType = this.applicant.signal.signalType === 2 ? '強いシグナル' : 'シグナル'
      const jobName = this.applicant.signal.jobName
      return `「${jobName}」に対する${signalType}が発生しました`
    }
  },
  methods: {
    handleChange(value) {
      this.reasons = value.reasons
    },
    handleClickDetail() {
      this.$emit("click:detail", this.applicant)
    },
    handleIgnoreApplicant () {
      this.$emit("click:ignoreApplicant", this.applicant)
    }
  }
}
</script>

<style scoped>
.requested {
  background-color: #00000011;
}
.isDisplayed {
  background-color: #00000011;
}
</style>
